import React, { lazy, Suspense } from 'react'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import 'semantic-ui-css/semantic.min.css'

import { Header } from '../Header/Header'
import { Footer } from '../Footer/Footer'
import { configureStore, history } from '../../redux/store'
import {
  PATH_ROOT,
  PATH_PRODUCTS,
  PATH_BATCH_LOOKUP,
  PATH_PRODUCT_NOTICES,
  PATH_BATCH_PRODUCT_CREATOR,
  PATH_BULK_EDITOR,
  PATH_CLUMP_EDITOR,
  PATH_BRAND_THEMES,
  PATH_PRODUCTS_NEW,
  PATH_PRODUCTS_EDIT,
  PATH_FEATURE_FLAGS,
  PATH_PRODUCTS_ALIAS_REMAP,
} from '../../consts'
import Notices from '../Products/Notices/Notices'
import BatchProductCreator from '../BatchProductCreator/BatchProductCreator'
import BulkEditor from '../BulkEditor/BulkEditor'
import { LocaleSpecificProvider } from '../Contexts/LocaleSpecificContext'
import ClumpEditor from '../ClumpEditor/ClumpEditor'
import BrandThemes from '../BrandThemes/BrandThemes'
import { CreateProductPage } from '../../pages/CreateProductPage'
import { EditProductPage } from '../../pages/EditProductPage'
import { FeatureFlagsPage } from '../../pages/FeatureFlagsPage'
import { ProductAliasRemap } from '../Products/AliasRemap/ProductAliasRemap'
import { ToastHandler } from './ToastHandler'

const LookupProductWrapper = lazy(() => import('../LookupProduct/LookupProductWrapper'))
const Products = lazy(() => import('../Products/Products'))
const store = configureStore()

export const App = () => {
  return (
    <Provider store={store}>
      <LocaleSpecificProvider>
        <ConnectedRouter history={history}>
          <Header />
          <Suspense fallback="">
            <span className="stretch" style={{ display: 'flex', flexDirection: 'column' }}>
              <Switch>
                <Route exact path={PATH_ROOT} component={LookupProductWrapper} />
                <Route exact path={PATH_PRODUCT_NOTICES} component={Notices} />
                <Route exact path={PATH_BATCH_PRODUCT_CREATOR} component={BatchProductCreator} />
                <Route exact path={PATH_BULK_EDITOR} component={BulkEditor} />

                <Route
                  exact
                  path={`${PATH_PRODUCTS_NEW}/:productId?`}
                  component={CreateProductPage}
                />
                <Route
                  // exact
                  path={`${PATH_PRODUCTS_EDIT}/:productId?`}
                  component={EditProductPage}
                />

                <Route exact path={`${PATH_PRODUCTS}/edit`} component={Products} />
                <Route exact path={PATH_CLUMP_EDITOR} component={ClumpEditor} />
                <Route exact path={PATH_BRAND_THEMES} component={BrandThemes} />
                <Route exact path={PATH_BATCH_LOOKUP} component={LookupProductWrapper} />
                <Route exact path={PATH_FEATURE_FLAGS} component={FeatureFlagsPage} />
                <Route exact path={PATH_PRODUCTS_ALIAS_REMAP} component={ProductAliasRemap} />
              </Switch>
            </span>
          </Suspense>
          <Footer />
          <ToastHandler />
        </ConnectedRouter>
      </LocaleSpecificProvider>
    </Provider>
  )
}
